/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IDeleteModalControllerScope extends controllers.IBaseModalControllerScope {
        deleteResult: Wars.Domain.Model.Dtos.Delete.DeleteResult,
        attemptRecursiveDelete: () => void;
    }

    export class DeleteModalController extends BaseModalController {

        constructor(
            private $scope: IDeleteModalControllerScope,
            private deleteService: services.DeleteService,
            private deleteResult: Wars.Domain.Model.Dtos.Delete.DeleteResult,
            close: any)
        {
            super($scope, close);
            this.$scope.deleteResult = deleteResult;
            this.$scope.attemptRecursiveDelete = () => this.attemptRecursiveDeleteInternal();
        }

        public attemptRecursiveDeleteInternal(): void {
            this.deleteService.deleteRecursivelyWithoutWarning(
                this.$scope.deleteResult.entityName,
                this.$scope.deleteResult.entityId, false).then(
                    (result: Wars.Domain.Model.Dtos.Delete.DeleteResult) => {
                        this.$scope.dismissModal({ cancel: false, deleteResult: result });
            });
        }

        public cancel(): void {
            this.$scope.dismissModal({ cancel: true, deleteResult: undefined });
        }
    }
}

warsApp.registerController('DeleteModalController', ['$scope', 'deleteService', 'deleteResult', 'close']);